const getHeaders = (token) => ({
  ...(token ? { Authorization: `Bearer ${token}` } : {}),
  'Content-Type': 'application/json',
});

const parseApiErrorFromBodyText = (text) => {
  if (!text || typeof text !== 'string') return '';
  try {
    const j = JSON.parse(text);
    if (j && typeof j.error === 'string') return j.error;
  } catch (_) {
    /* plain text */
  }
  return text;
};

const readJson = async (res) => {
  const text = await res.text();
  if (!res.ok) {
    throw new Error(parseApiErrorFromBodyText(text) || `Request failed (${res.status})`);
  }
  if (!text) return [];
  try {
    return JSON.parse(text);
  } catch {
    return [];
  }
};

export function publishEmailPrefKey(tenantId, propertyId) {
  return `schedule_publish_email_${tenantId || ''}_${propertyId || ''}`;
}

export function loadPublishEmailPref(tenantId, propertyId) {
  try {
    return localStorage.getItem(publishEmailPrefKey(tenantId, propertyId)) === '1';
  } catch {
    return false;
  }
}

export function savePublishEmailPref(tenantId, propertyId, enabled) {
  try {
    localStorage.setItem(publishEmailPrefKey(tenantId, propertyId), enabled ? '1' : '0');
  } catch (_) {
    /* ignore */
  }
}

export async function createPublishedScheduleBatch(baseUrl, token, body) {
  const res = await fetch(`${baseUrl}conductor/published-schedule/batch`, {
    method: 'POST',
    headers: getHeaders(token),
    body: JSON.stringify(body),
  });
  return readJson(res);
}

export async function fetchPublishedSchedules(baseUrl, token, tenantId, propertyId, publishBatchId) {
  let url = `${baseUrl}conductor/published-schedule/by-tenant?tenant_id=${encodeURIComponent(tenantId)}&property_id=${encodeURIComponent(propertyId)}`;
  if (publishBatchId) {
    url += `&publish_batch_id=${encodeURIComponent(publishBatchId)}`;
  }
  const res = await fetch(url, { method: 'GET', headers: getHeaders(token) });
  return readJson(res);
}

export async function submitPublishedBatchForApproval(baseUrl, token, tenantId, propertyId, publishBatchId) {
  const url = `${baseUrl}conductor/published-schedule/batch/${encodeURIComponent(
    publishBatchId
  )}/submit-for-approval?tenant_id=${encodeURIComponent(tenantId)}&property_id=${encodeURIComponent(propertyId)}`;
  const res = await fetch(url, { method: 'POST', headers: getHeaders(token) });
  return readJson(res);
}

export async function approvePublishedBatch(baseUrl, token, tenantId, propertyId, publishBatchId, approvedBy) {
  const url = `${baseUrl}conductor/published-schedule/batch/${encodeURIComponent(
    publishBatchId
  )}/approve?tenant_id=${encodeURIComponent(tenantId)}&property_id=${encodeURIComponent(propertyId)}`;
  const res = await fetch(url, {
    method: 'POST',
    headers: getHeaders(token),
    body: JSON.stringify({ approvedBy: approvedBy || null }),
  });
  return readJson(res);
}

export async function rejectPublishedBatch(baseUrl, token, tenantId, propertyId, publishBatchId, updatedBy) {
  let url = `${baseUrl}conductor/published-schedule/batch/${encodeURIComponent(
    publishBatchId
  )}/reject?tenant_id=${encodeURIComponent(tenantId)}&property_id=${encodeURIComponent(propertyId)}`;
  if (updatedBy) {
    url += `&updated_by=${encodeURIComponent(updatedBy)}`;
  }
  const res = await fetch(url, { method: 'POST', headers: getHeaders(token) });
  return readJson(res);
}

export async function publishPublishedBatch(baseUrl, token, tenantId, propertyId, publishBatchId, publishedBy, sendEmailNotifications) {
  const url = `${baseUrl}conductor/published-schedule/batch/${encodeURIComponent(
    publishBatchId
  )}/publish?tenant_id=${encodeURIComponent(tenantId)}&property_id=${encodeURIComponent(propertyId)}`;
  const res = await fetch(url, {
    method: 'POST',
    headers: getHeaders(token),
    body: JSON.stringify({
      publishedBy: publishedBy || null,
      sendEmailNotifications: Boolean(sendEmailNotifications),
    }),
  });
  return readJson(res);
}
